import * as React from 'react';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import { workspaceActions } from '../../../WorkspaceActions';
import { DashboardContext, Filters } from '@acoer/ac-js-lib-charts';
import { useCallback } from 'react';
import * as actions from '../../DashboardActions';
import TextField from '@mui/material/TextField';

interface EditSavedFilterProps {
    handleClose: () => void;
    setEditTemplate: (template: any) => void;
    editTemplate: any;
    area: string;
}

const EditSavedFilter: React.FC<EditSavedFilterProps> = ({
    handleClose,
    setEditTemplate,
    editTemplate,
    area,
}) => {
    const dispatch = useDispatch();
    const areaConfigs = useSelector((state: any) => state.areaConfigs);
    const filterValues = useSelector(
        (state: any) => state.dashboard.filters || {}
    );
    const savedFilterConfiguration = useSelector(
        (state: any) =>
            state.workspace && state.workspace['saved-filters-configuration']
    );
    const [templateName, setTemplateName] = React.useState<string>(
        editTemplate && editTemplate.name
    );
    const [templateFilters, setTemplateFilters] = React.useState<any>(
        editTemplate && editTemplate.filters
    );
    const type = 'CASE';
    const handleCancel = () => {
        setEditTemplate(null);
    };

    const getFilterValues = useCallback(
        (
            value: string,
            filterId: string | undefined,
            isTypeahead: boolean | undefined
        ) => {
            dispatch(
                actions.getFilterValues(
                    type.toUpperCase(),
                    area,
                    value,
                    filterId,
                    isTypeahead
                )
            );
        },
        [dispatch, type, area]
    );

    const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTemplateName(event.target.value);
    };

    const handleSetFilters = (value) => {
        const updatedFilter = { ...templateFilters, ...value };
        setTemplateFilters(updatedFilter);
    };

    const handleRemoveFilter = (value) => {
        const clone = structuredClone(templateFilters);
        delete clone[value];
        setTemplateFilters(clone);
    };

    const handleUpdateTemplate = () => {
        const updatedTemplate = {
            name: templateName,
            filters: templateFilters,
        };
        const updatedTemplates = savedFilterConfiguration.map((item: any) => {
            if (item.name === editTemplate.name) {
                return updatedTemplate;
            }
            return item;
        });

        dispatch(
            workspaceActions?.setWorkspaceConfiguration(
                area,
                'saved-filters-configuration',
                updatedTemplates
            )
        );

        setEditTemplate(null);
    };

    return (
        <div>
            <DialogTitle>Edit Saved Filter</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item xs={4}>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="editSavedTemplateName"
                            name="templateName"
                            label="Template Name"
                            fullWidth
                            variant="outlined"
                            onChange={handleNameChange}
                            value={templateName}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DashboardContext.Provider
                            value={{
                                type,
                                filters:
                                    areaConfigs[area]['dashboard-configuration']
                                        .filters,
                            }}
                        >
                            <Filters
                                filterValues={filterValues}
                                savedFilters={templateFilters}
                                getFilterValues={getFilterValues}
                                setFilters={handleSetFilters}
                                onHandleRemoveFilter={handleRemoveFilter}
                            />
                        </DashboardContext.Provider>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button onClick={handleUpdateTemplate} variant={'contained'}>
                    Update Filters
                </Button>
            </DialogActions>
        </div>
    );
};

export default EditSavedFilter;
